import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "dialog-wrapper" };
const _hoisted_2 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_3 = { class: "require-field-wrapper pa-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_form = _resolveComponent("v-form");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCancel,
        onKeydown: _withKeys(_ctx.handleClickCancel, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _withDirectives((_openBlock(), _createBlock(_component_v_btn, _mergeProps(props, { onClick: _ctx.handleClickOpenDialogBtn }), {
                default: _withCtx(() => [
                    _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" mdi-plus ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [3]
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}add_title`)), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                [
                    _directive_btn_style,
                    void 0,
                    "config",
                    {
                        primary: true,
                        outlined: true,
                        info: true,
                        "size-l": true,
                        "width-fill": true
                    }
                ]
            ])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_DialogHeader, {
                    title: _ctx.$t(`${_ctx.lc}add_title`),
                    "on-cancel": _ctx.handleClickCancel
                }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                _createVNode(_component_v_form, {
                    ref: "formRef",
                    modelValue: _ctx.formValid,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formValid) = $event)),
                    onSubmit: _withModifiers(_ctx.handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createCommentVNode(" 그룹명 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.lc}group_name`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.name,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.name) = $event)),
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t(`${_ctx.lc}group_name_placeholder`),
                                            rules: _ctx.formRules.name,
                                            onBlur: _ctx.onBlurNameField
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules", "onBlur"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "onSubmit"]),
                _createVNode(_component_v_divider),
                _createVNode(_component_DialogFooter, {
                    cancel: "",
                    ok: "",
                    "on-cancel": _ctx.handleClickCancel,
                    "on-ok": _ctx.handleClickOk
                }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
